module.exports = __webpack_public_path__ + "static/media/29EUNOG4.1c1fc5c8.jpg";